// Escaped, inline-only formatting: safe in compact previews, with no links or
// whitespace styles that would override their own ellipsis/line clamps.
export function formatWaTextSegment(str, isDark = false) {
  const safe = String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const codeBg = isDark ? "rgba(255,255,255,0.12)" : "#f5f5f5";
  const codeColor = isDark ? "#FAFAFA" : "inherit";
  return safe
    .replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>")
    .replace(/\*([^*\n]+)\*/g, "<strong>$1</strong>")
    .replace(/_([^_\n]+)_/g, "<em>$1</em>")
    .replace(/~([^~\n]+)~/g, "<s>$1</s>")
    .replace(/`([^`\n]+)`/g, `<code style="background:${codeBg};color:${codeColor};padding:1px 4px;border-radius:3px;font-family:monospace;font-size:11px">$1</code>`);
}

export function formatWaTextInlineHtml(text, isDark = false) {
  return text ? formatWaTextSegment(text, isDark) : "";
}
